import * as React from 'react';
import { cn } from 'lib/utils';
import { Box } from 'components/ui/Box';
import { Skeleton } from 'components/ui/skeleton';
import { Formatter } from 'utils/Formatter';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  data?: any[];
  loading?: boolean;
}

export const ObservationsList = ({ data, loading, className }: Props) => {
  if (!data || loading) {
    return (
      <div className={cn('flex gap-6', className)}>
        <ObservationListSkeleton />
      </div>
    );
  }

  const spanHeight = data.length * 200;

  return (
    <div className={cn('relative', className)}>
      <span
        className='absolute top-0 left-[5px] h-[100px] w-[1px] bg-gray-400'
        style={{ height: `${spanHeight}px` }}
      />
      {data.map((obs, index) => (
        <div key={index} className='first:mt-6 mt-14'>
          <p className='text-xs flex items-center'>
            <span className="flex w-[11px] h-[11px] mr-5 bg-gray-400 rounded-full"></span>
            {Formatter.dateFull(obs.createdAt)} <span className='font-GilroySemibold ml-3'>{obs.user.name.toUpperCase()}</span>
          </p>
          <Box className='mt-4 ml-7'>
            <p className='font-sans text-xs'>{obs.observation}</p>
          </Box>
        </div>
      ))}
    </div>
  );
};

const ObservationListSkeleton = () => {
  return (
    <div className='mt-6 w-full'>
      <Skeleton className='w-full h-2 ml-7' />
      <Skeleton className='mt-4 ml-7 w-full h-10' />
    </div>
  )
}